const gql = require("graphql-tag");

const COMPANIES = gql`
  query($data: CompanyFindInput) {
    Companies(data: $data) {
      id
      name
      type
      userlimit
      passiveDate
      description
      isActive
    }
  }
`;

const COMPANIES_DROPDOWN = gql`
  query($data: CompanyFindInput) {
    Companies(data: $data) {
      id
      name
    }
  }
`;

export const companiesQueries = {
  COMPANIES,
  COMPANIES_DROPDOWN, 
};
